import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "contexts/AuthContext";
import { BIM, CreateBIMPayload } from "utils/bim";

const useCreateBIMMutation = (projectId: string) => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (payload: CreateBIMPayload) => {
      if (!projectId) return;
      const { data } = await authApi.post<BIM>(`/project/${projectId}/bims`, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["bims", projectId],
      });
    },
  });
};

export default useCreateBIMMutation;
